'use strict';

import React from 'react'

import Layout from '@Layout/ECFront'

import HolidaysMessage from '@/HolidaysMessage'

import UserCard from '@/UserCard'

import _ from 'lodash'

const { app, moment } = window;

export default class UserCardPage extends React.Component
{
	state =
	{
		id: '',
		name: 'Nom prénom',
		company: 'Votre CE'
	};

	UNSAFE_componentWillMount ()
	{
		const component = this, props = this.props;

		app.resetFunctions();

		app.push(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});

		component.handleSessionChange('componentWillMount');
	}

	componentWillUnmount ()
	{
		const component = this, props = this.props;

		app.delete(
		{
			event: 'sessionChange',
			cb: component.handleSessionChange
		});
	}

	handleSessionChange = (source) =>
	{
		const component = this, props = this.props, state = this.state;

		if (!app.state.session.EC) return;

		component.setState(
		{
			name: app.state.session.firstname + ' ' + app.state.session.lastname,
			company: app.state.session.EC.company,
			id: app.state.session.id
		});
	}

	render ()
	{
		const component = this, props = this.props, state = this.state;

		return (
			<Layout page_title="Mon compte" history={ props.history }>

				<div className="page-content">

					<HolidaysMessage />

					<div className="o-content">

						<UserCard className="in-modal" hide-guide />

					</div>

				</div>

			</Layout>
		);
	}
}